import Swiper from 'swiper'
import { Autoplay, EffectFade, Navigation } from 'swiper/modules'


const initSwiper = () => {
    new Swiper('.swiper', {
        modules: [Autoplay, EffectFade],
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 1000,
        allowTouchMove: false,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
    })

    new Swiper('.testimonials-swiper', {
        modules: [Navigation],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            enabled: true,
            nextEl: '.testimonials-container .swiper-button-next',
            prevEl: '.testimonials-container .swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            1025: {
                slidesPerView: 3,
            },
        }
    })
}

export default initSwiper
